/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Previewretry3Inputs */

const en_coinvestments_draftemail_previewretry3 = /** @type {(inputs: Coinvestments_Draftemail_Previewretry3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Coinvestments_Draftemail_Previewretry3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_previewretry3 = /** @type {((inputs?: Coinvestments_Draftemail_Previewretry3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Previewretry3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_previewretry3(inputs)
});
export { coinvestments_draftemail_previewretry3 as "coInvestments_draftEmail_previewRetry" }